module.exports = __webpack_public_path__ + "static/media/insta-shadow.eefcf839.png";